import { ArrowDown, ArrowRightLeft, ArrowUp } from "lucide-react";
import type { StockArticle, StockMovement } from "@/lib/stock.api";
import { cn } from "@/lib/utils";
import { MOVEMENT_LABELS, MOVEMENT_TONES } from "../stock.constants";

export function StockArticleStatusBadge({ article }: { article: StockArticle }) {
  return (
    <span
      className={cn(
        "shrink-0 rounded border px-2 py-0.5 text-[10.5px] font-semibold",
        article.active
          ? "border-success-border bg-success-bg text-success-text"
          : "border-danger-border bg-danger-bg text-danger-text",
      )}
    >
      {article.active ? "Actif" : "Désactivé"}
    </span>
  );
}

export function StockMovementBadge({ type }: { type: StockMovement["type"] }) {
  return (
    <span
      className={cn(
        "inline-flex rounded border px-2 py-0.5 text-[10.5px] font-semibold",
        MOVEMENT_TONES[type],
      )}
    >
      {MOVEMENT_LABELS[type]}
    </span>
  );
}

export function StockMovementIcon({ type }: { type: StockMovement["type"] }) {
  if (type === "IN") return <ArrowUp size={13} />;
  if (type === "OUT") return <ArrowDown size={13} />;
  return <ArrowRightLeft size={13} />;
}
